<template>
  <el-form ref="form" :model="form" class="box-set" label-width="120px">
    <el-card header="设置规则名称" shadow="naver">
      <el-form-item label="名称" prop="package_name" :rules="{required: true, message: '促销促销', trigger: 'blur'}">
        <el-col :span="20">
          <el-input v-model="form.package_name" :maxlength=30 placeholder="最多30个字"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="选择主商品">
        <el-col :span="20">
          <el-button type="primary" class="el-icon-plus" @click="relMainClick" size="mini" round>主商品选择
          </el-button>
          <GoodsSelect :items-visible="mainVisible" :get-status="setMainStatus" :single="singleData"
                       :rel-items-ids="relMain"
                       :item-type="form.item_type" @chooseStore="chooseMainAction"
                       @closeStoreDialog="closeMainDialogAction"></GoodsSelect>
        </el-col>
        <el-table :data="relMain" style="line-height: normal">
          <el-table-column label="ID" prop="item_id" width="60"></el-table-column>
          <el-table-column label="名称" prop="item_name" min-width="200"></el-table-column>
          <el-table-column label="价格" width="90">
            <template slot-scope="scope">
              <el-input v-model="scope.row.price" width="90" size="mini"></el-input>
            </template>
          </el-table-column>
        </el-table>

      </el-form-item>

    </el-card>
    <el-card header="选择适用商品 (最大选择10个商品)" shadow="naver">
      <SkuSelector @change="getItems" @newPrice="getNewPrice" :data="relItems" :limit="1"
                   :hiddenData="relMain"></SkuSelector>
    </el-card>
    <el-card header="设置商品组合" shadow="naver">
      <!--<el-form-item label="组合价">-->
      <!--{{form.new_price}}元-->
      <!--</el-form-item>-->
      <el-form-item label="适用会员">
        <el-checkbox-group v-model="validGrade">
          <el-checkbox v-for="grade in memberGrade" :label="grade.grade_id" :key="grade.grade_id">
            {{ grade.grade_name }}
          </el-checkbox>
          <el-checkbox v-for="vipdata in vipGrade" :label="vipdata.lv_type" :key="vipdata.lv_type">
            付费{{ vipdata.grade_name }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="适用平台">
        <el-radio-group v-model="form.used_platform">
          <el-radio :label="0">全场可用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="适用店铺id">
        <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容，正确示范：2156,2145,2333 每个店铺id后要有一个英文格式的逗号，最后一个店铺id后不需要加。"
            v-model="form.shopid_str">
        </el-input>
      </el-form-item>
      <el-form-item label="适用店铺标签">
        <el-tag
            :key="tag.tag_id"
            v-for="tag in form.shop_tags"
            closable
            :disable-transitions="false"
            @close="handleCloseTag(tag)">
          {{ tag.tag_name }}
        </el-tag>
        <el-button type="primary" size="mini" @click="selectShopdialog">添加标签</el-button>
      </el-form-item>
      <el-form-item label="有效期">
        <el-col :span="20">
          <el-date-picker
              v-model="activity_date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="生效时间"
              end-placeholder="过期时间"
              format="yyyy/MM/dd HH:mm:ss"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-col>
      </el-form-item>
    </el-card>
    <div class="content-center">
      <el-button type="primary" v-if="hasSaveButton" @click="submitActivityAction()">保存</el-button>
      <el-button @click.native="handleCancel">返回</el-button>
    </div>
    <div>
      <el-dialog title="适用店铺" :visible.sync="selectShopVisi" width="30%" style="padding:20px 10px"
                 :before-close="handleClose">
        <span>当前已选中:</span>
        <el-tag
            :key="tag.tag_id"
            v-for="tag in form.shop_tags"
            closable
            size="small"
            :disable-transitions="false"
            @close="handleCloseTag(tag)" style="margin-top:5px;">
          {{ tag.tag_name }}
        </el-tag>
        <el-table :data="shopTagData" style="width:100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="100"></el-table-column>
          <el-table-column prop="tag_id" label="标签id"></el-table-column>
          <el-table-column prop="tag_name" label="标签名称">
            <template slot-scope="scope">
              <el-tag :color="scope.row.tag_color" size="mini" style="color:#ffffff">{{ scope.row.tag_name }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="selectShopVisi = false">取 消</el-button>
          <el-button type="primary" @click="selectShopVisi = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </el-form>
</template>

<script>
import GoodsSelect from '@/components/goodsSelect'
import SkuSelector from '@/components/function/skuSelectorPrice'
import {getGradeList} from '../../../../api/membercard'
import {listVipGrade} from '../../../../api/cardticket'
import {getTagList} from '../../../../api/marketing'
import {createPackagePromotions, getPackagePromotionsInfo, updatePackagePromotions} from '../../../../api/promotions'

export default {
  inject: ['refresh'],
  components: {
    SkuSelector,
    GoodsSelect
  },
  data () {
    return {
      relItems: [],
      relItemsTemp: [],
      validGrade: [],
      vipGrade: [],
      memberGrade: [],
      activity_date: '',
      selectShopVisi: false,
      form: {
        package_name: '',
        used_platform: 0,
        free_postage: 1,
        new_price: 0,
        items: [],
        main_item: {},
        valid_grade: [],
        shopid_str: '',
        shop_tags: []
      },
      relMain: [],
      setMainStatus: false,
      mainVisible: false,
      singleData: true,
      hasSaveButton: true,
      shopTagData: [],
      shopidTag: {
        page: 1,
        pageSize: 15,
        total_count: ''
      }
    }
  },
  methods: {
    submitActivityAction () {
      const that = this
      if (this.activity_date.length > 0) {
        this.form.start_time = this.activity_date[0] / 1000
        this.form.end_time = this.activity_date[1] / 1000
      }

      if (this.validGrade.length > 0) {
        this.form.valid_grade = this.validGrade
      }

      if (this.relMain.length > 0) {
        this.form.main_item = {'item_id': this.relMain[0].item_id, 'item_price': this.relMain[0].price}
      }
      if (this.$route.params.package_id) {
        updatePackagePromotions(this.$route.params.package_id, this.form).then(response => {
          this.loading = false
          this.$message({
            message: '修改成功',
            type: 'success',
            duration: 2 * 1000,
            onClose () {
              that.refresh()
              that.$router.go(-1)
            }
          })
        }).catch()
      } else {
        createPackagePromotions(this.form).then(response => {
          this.loading = false
          this.$message({
            message: '添加成功',
            type: 'success',
            duration: 2 * 1000,
            onClose () {
              that.refresh()
              that.$router.go(-1)
            }
          })
        }).catch()
      }
    },
    getNewPrice (new_price) {
      this.form.new_price = new_price
    },
    getItems (data) {
      let items = []
      this.relItemsTemp = JSON.parse(JSON.stringify(data))
      data.forEach(item => {
        items.push({'item_id': item.itemId, 'new_price': item.new_price})
      })
      this.form.items = items
    },
    getListVipGrade () {
      listVipGrade().then(response => {
        if (response != undefined && response.data.data && response.data.data.length > 0) {
          this.vipGrade = response.data.data
        }
      })
    },
    getGradeList () {
      getGradeList().then(response => {
        if (response != undefined && response.data.data && response.data.data.length > 0) {
          var result = response.data.data
          if (result) {
            this.memberGrade = result
          }
        }
      })
    },
    getPackagePromotionsInfo (id) {
      getPackagePromotionsInfo(id).then(response => {
        this.form.used_platform = response.data.data.used_platform
        this.form.free_postage = response.data.data.free_postage
        this.form.package_name = response.data.data.package_name
        this.form.shopid_str = response.data.data.shopid_str
        this.form.shop_tags = response.data.data.shop_tags
        this.validGrade = response.data.data.valid_grade
        response.data.data.itemTreeLists.forEach(item => {
          item.new_price = response.data.data.new_price[item.itemId] / 100
        })

        this.relMain = JSON.parse(JSON.stringify(response.data.data.mainItem))
        this.relMain[0].price = response.data.data.mainItem[0].price / 100
        this.relItems = response.data.data.itemTreeLists
        this.activity_date = [response.data.data.start_time * 1000, response.data.data.end_time * 1000]
      })
    },
    closeMainDialogAction () {
      this.mainVisible = false
    },
    chooseMainAction (data) {
      this.mainVisible = false
      this.relMain = JSON.parse(JSON.stringify(data))
      this.relMain[0].price = this.relMain[0].price / 100
      let index = this.relItemsTemp.findIndex(n => n.itemId === this.relMain[0].itemId)
      this.relItemsTemp.splice(index, 1)
      this.relItems = JSON.parse(JSON.stringify(this.relItemsTemp))
    },
    relMainClick () {
      this.mainVisible = true
      this.setMainStatus = true
    },
    handleCancel () {
      this.$router.back(-1)
    },
    handleClose () {
      this.selectShopVisi = false
    },
    handleCloseTag (tag) {
      this.form.shop_tags.forEach(function (value, key, arr) {
        if (tag.tag_id === value.tag_id) {
          arr.splice(key, 1)
        }
      })
    },
    selectShopdialog () {
      this.selectShopVisi = true
      let params = this.shopidTag
      getTagList(params).then(response => {
        this.shopTagData = response.data.data.list
      }).catch()
    },
    handleSelectionChange (val) {
      val.forEach(tag => {
        let isExist = 0
        this.form.shop_tags.forEach(item => {
          if (item.tag_id === tag.tag_id) {
            isExist = 2
          }
        })
        if (isExist === 0) {
          this.form.shop_tags.push({'tag_id': tag.tag_id, 'tag_name': tag.tag_name})
        }
      })
      console.log(this.form.shop_tags)
    }
  },
  mounted () {
    if (this.$route.query.isshow) {
      this.hasSaveButton = false
    }
    this.getListVipGrade()
    this.getGradeList()
    if (this.$route.params.package_id) {
      this.getPackagePromotionsInfo(this.$route.params.package_id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// add.vue?36fa9b0a